import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <main className="min-h-screen flex items-center justify-center">
      <div className="hero-content text-center">
        <div className="max-w-sm">
          <h1 className="text-6xl font-bold">404</h1>
          <h2 className="text-2xl text-gray-500 font-semibold mt-1">
            Seite nicht gefunden
          </h2>
          <p className="py-6">
            Hoppla! Die von dir gesuchte Seite existiert leider nicht oder wurde
            verschoben.
          </p>
          <Link to="/" className="text-blue-500 hover:text-blue-700 underline">
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
